import {
  API_BASE_URL,
  CMS_UPLOAD_FILE_PK,
  CMS_UPLOAD_USECASE,
} from "@/constants";
import axios from "axios";

const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_upload_file = API_BASE_URL + CMS_UPLOAD_FILE_PK;

class UploadFileService {
  constructor(token, role) {
    this.token = token;
    this.role = role;
  }

  async uploadUsecase(file, idForm, purpose, usecase) {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", idForm);
      formData.append("purpose", purpose);
      formData.append("usecase", usecase);

      const response = await axios.post(url_upload_usecase, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          role: this.role,
          Authorization: `Bearer ${this.token}`,
          accept: "*/*",
        },
      });

      return response.data;
    }
  }

  async uploadFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(url_upload_file, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        role: this.role,
        Authorization: `Bearer ${this.token}`,
        accept: "*/*",
      },
    });
    return response.data;
  }
}
export default UploadFileService;
